import { render, staticRenderFns } from "./AncillaryFlightBaggage.vue?vue&type=template&id=5cb06614&scoped=true"
import script from "./AncillaryFlightBaggage.vue?vue&type=script&lang=js"
export * from "./AncillaryFlightBaggage.vue?vue&type=script&lang=js"
import style0 from "./AncillaryFlightBaggage.vue?vue&type=style&index=0&id=5cb06614&prod&lang=scss"
import style1 from "./AncillaryFlightBaggage.vue?vue&type=style&index=1&id=5cb06614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb06614",
  null
  
)

export default component.exports